import React from 'react';
import { cn } from '@/shared/utils/utils';

interface EmptyStateIllustrationProps {
  className?: string;
}

export const EmptyStateIllustration: React.FC<EmptyStateIllustrationProps> = ({
  className,
}) => {
  return (
    <img
      src="/undraw-illustrations/undraw_no-data_ig65.svg"
      alt="Empty state illustration"
      className={cn('object-contain w-1/4 2xl:w-1/', className)}
    />
  );
};
